export default class Event {
	constructor(eventName) {
		this.eventName = eventName;
		this.callbacks = [];
	}

	registerCallback(callback) {
    this.callbacks.push(callback);
	}

	unregisterCallback(callback) {
    const index = this.callbacks.indexOf(callback);
		if (index > -1) {
			this.callbacks.splice(index, 1);
		}
	}

	emit(data) {
    const callbacks = this.callbacks.slice(0);
		callbacks.forEach( callback => {
			callback(data);
		});
	}
}
